/* eslint-disable max-lines */
import {
	financialStatementsSelectors,
	gameSelectors,
	gameActions,
	adSelectors,
	storeSelectors,
	employeesSelectors,
	uiSelectors,
	levelSelectors,
	carSelectors,
	warehouseSelectors,
	characterSelectors,
} from '~/store';
import {
	EXPENSES,
	INCOMES,
	CASH_UPDATES,
	COMPONENTS_NAMES,
	CHARACTERS_SLUG,
	MAIN_SCREEN_MODALS,
	LEVELS_TO_UNLOCK_FEATURES,
	LEVELS_WITH_NEW_CUSTOMER_TYPES,
	DRAGGABLE_COMPONENTS,
	TURN_PHASES,
	LOADING_TYPES
} from '~/lib/constants';
import FINANCIAL_STATEMENTS_TABS from '~/containers/financial-statments/TabEnum'
import { CashUpdateBuilder } from '~/models';
import { setTutorialStep, getTutorialStorageType } from '~/lib/financialTutorialStorage';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

function addCreditCustomerPayments(getState, dispatch) {
	const payments = financialStatementsSelectors.getAccountReceivablesForCurrMonth(getState());
	if (payments > 0) {
		dispatch(addCashUpdateToDisplay(
			CASH_UPDATES.INCOME,
			INCOMES.CREDIT_CUSTOMERS,
			payments
		));
	}
}

function addMonthlyRentExpense(getState, dispatch) {
	const storeRent = storeSelectors.getStoreRent(getState());
	dispatch(addCashUpdateToDisplay(CASH_UPDATES.EXPENSE, EXPENSES.RENT, storeRent));
}

function addMonthlyAdExpense(getState, dispatch) {
	const adsRent = adSelectors.getRunningAdsRent(getState());
	if (adsRent > 0)
		dispatch(addCashUpdateToDisplay(CASH_UPDATES.EXPENSE, EXPENSES.ADS, adsRent));
}

function addMonthlyEmployeeExpense(getState, dispatch) {
	const hiredEmployees = employeesSelectors.getHiredEmployees(getState());
	let salaries = hiredEmployees.reduce((total, employee) =>
		total + employeesSelectors.getEmployeeSalary(getState(), employee), 0);

	if (salaries > 0)
		dispatch(addCashUpdateToDisplay(CASH_UPDATES.EXPENSE, EXPENSES.EMPLOYEE, salaries));
}

function addMonthlyCarExpense(getState, dispatch) {
	const rent = carSelectors.getCarRent(getState());

	if (rent > 0)
		dispatch(addCashUpdateToDisplay(CASH_UPDATES.EXPENSE, EXPENSES.CAR, rent));
}

function addMonthlyWarehouseExpense(getState, dispatch) {
	const rent = warehouseSelectors.getWarehouseRent(getState());

	if (rent > 0)
		dispatch(addCashUpdateToDisplay(CASH_UPDATES.EXPENSE, EXPENSES.WAREHOUSE, rent));
}

function _isAtLeast2ProductsNumberToPurchaseChanged(productsToPurchase) {
	return Object.entries(productsToPurchase)
		.map(([key, numberToPurchase]) => ({ key, numberToPurchase }))
		.filter((e) => e.numberToPurchase > 0).length >= 2;
}

function _isAllSellingPricesChanged(sellingPricesChanged) {
	return Object.entries(sellingPricesChanged)
		.map((e) => ({ key: e[0], isChanged: e[1] }))
		.every((e) => e.isChanged);
}


export function changeActiveModal(modalName) {
	return { type: types.UI_ACTIVE_MODAL_CHANGED, modalName };
}

export function setPreviouslyActiveModal(modalName) {
	return { type: types.UI_SET_PREVIOUSLY_ACTIVE_MODAL, modalName };
}

export function setGameMenuReturnRoute(route) {
	return { type: types.UI_SET_GAME_MENU_RETURN_ROUTE, route };
}

export function showNetworkErrorModal() {
	return { type: types.UI_SHOW_NETWORK_ERROR_MODAL };
}

export function hideNetworkErrorModal() {
	return { type: types.UI_HIDE_NETWORK_ERROR_MODAL };
}

export function enterLevelFailedReviewMode() {
	return { type: types.UI_ENTER_LEVEL_FAILED_REVIEW_MODE };
}

export function exitLevelFailedReviewMode() {
	return { type: types.UI_EXIT_LEVEL_FAILED_REVIEW_MODE };
}

export function closeActiveModal() {
	return changeActiveModal(null);
}

export function displayMonthlyCashUpdates() {
	return (dispatch, getState) => {
		addMonthlyRentExpense(getState, dispatch);
		addMonthlyAdExpense(getState, dispatch);
		addMonthlyEmployeeExpense(getState, dispatch);
		addMonthlyCarExpense(getState, dispatch);
		addMonthlyWarehouseExpense(getState, dispatch);
		addCreditCustomerPayments(getState, dispatch);
	};
}

export function addCashUpdateToDisplay(type, name, amount, isNew = false) {
	const cashUpdate = new CashUpdateBuilder()
		.withType(type)
		.withName(name)
		.withAmount(amount)
		.build();

	let actionType;

	if (type === CASH_UPDATES.INCOME) {
		actionType = types.UI_ADD_INCOME_TO_DISPLAY;
	}
	else {
		actionType = isNew
			? types.UI_ADD_NEW_EXPENSE_TO_DISPLAY
			: types.UI_ADD_EXPENSE_TO_DISPLAY;
	}

	return {
		type: actionType,
		cashUpdate: cashUpdate.toPlainObj()
	};
}

export function addNewExpenseToDisplay(name, amount) {
	return (dispatch, getState) => {
		const expenses = uiSelectors.getExpenses(getState());
		const hasPendingExpenseOfSameTypeToDisplay =
			expenses.filter((expense) => expense.name === name).length > 0;
		let newAmount = amount;

		if (hasPendingExpenseOfSameTypeToDisplay) {
			const existingExpense = expenses.filter((expense) => expense.name === name)
			newAmount = existingExpense[0]?.amount + amount;
			dispatch(resetDisplayedCashUpdates());
		}
		dispatch(gameActions.incrementCash(-1 * amount));
		dispatch(addCashUpdateToDisplay(CASH_UPDATES.EXPENSE, name, newAmount, true));
	};
}

export function shouldDisplayPowerModalForProcurementScreen(isShown) {
	return { type: types.UI_PROCUREMENT_DISMISSED_POWER_MODAL, isShown };
}

export function shouldDisplayPowerModalFoHrScreen(isShown) {
	return { type: types.UI_SET_HR_POWER_MODAL_VISIBLE, isShown };
}

export function resetHasClosedNewLevelPopup() {
	return (dispatch, getState) => {
		dispatch({ type: types.UI_LEVEL_NEW_MODAL_CLOSED, closed: false });
	}; 
}

export function resetDisplayedCashUpdates() {
	return { type: types.UI_RESET_DISPLAYED_CASH_UPDATES };
}

export function setDraggableComponentVisibility(componentName, isVisible) {
	return (dispatch) => {
		dispatch({ type: types.UI_DRAGGABLE_COMPONENT_SHOW, componentName, isVisible });
	};
}

export function closeOpenedDraggables() {
	return (dispatch, getState) => {
		const draggablesVisibility = uiSelectors.getDraggablesVisibility(getState());

		Object.entries(draggablesVisibility)
			.map(([compName, isVisible]) => {
				if (isVisible) {
					dispatch(setDraggableComponentVisibility(compName, false));
				}
			});
	};
}

export function showNewLevelModal() {
	return (dispatch) => {
		dispatch({ type: types.UI_LEVEL_NEW_MODAL_CLOSED, closed: false });

		dispatch(closeOpenedDraggables());
		dispatch(changeActiveModal(MAIN_SCREEN_MODALS.NEW_LEVEL));
		dispatch(updateShouldShowLevelStory(true));
	};
}

export function closeNewLevelModal() {
	return (dispatch, getState) => {
		const currentLevel = levelSelectors.getLevelNumber(getState());

		if (currentLevel === 2) {
			dispatch({ type: types.UI_LEVEL_NEW_MODAL_FOR_LEVEL_2_CLOSED });
		}

		if (currentLevel === LEVELS_TO_UNLOCK_FEATURES.FINANCIAL_STATEMENTS_VIEW) {
			//	used to show financial statements hinting arrow
			dispatch({ type: types.UI_LEVEL_NEW_MODAL_FOR_LEVEL_3_CLOSED });
		}

		if (currentLevel === LEVELS_TO_UNLOCK_FEATURES.PLAYER_HEALTH) {
			dispatch(openDraggable(DRAGGABLE_COMPONENTS.HEALTH_BAR_TUTORIAL));
		}
		else if (currentLevel === LEVELS_TO_UNLOCK_FEATURES.RATIOS_TUTORIAL) {
			dispatch(openDraggable(DRAGGABLE_COMPONENTS.RATIOS_TUTORIAL));
		} else if (currentLevel === LEVELS_TO_UNLOCK_FEATURES.BREAKEVEN_TUTORIAL) {
			//	close profit distribution wallet as to show breakeven tutorial
			dispatch(closeDraggable(DRAGGABLE_COMPONENTS.WALLET_PROFIT_DISTRIBUTION));
			dispatch(openDraggable(DRAGGABLE_COMPONENTS.BREAKEVEN_TUTORIAL));
		} else {
			//	Added for desk item levitation animation
			//	level 5 levitation will be triggered after 
			//	health bar tutorial is closed
			dispatch({
				type: types.UI_LEVEL_NEW_MODAL_CLOSED,
				closed: true,
			});
		}


		dispatch(closeActiveModal());
	};
}

export function notifyAsActiveComponent(activeComponentName) {
	return (dispatch) => {
		switch (activeComponentName) {
			case COMPONENTS_NAMES.PROCUREMENT:
				dispatch({ type: types.UI_PROCUREMENT_OPENED });
				break;
			case COMPONENTS_NAMES.PROCUREMENT_BUY_MODAL:
				dispatch({ type: types.UI_PROCUREMENT_BUY_MODAL_OPENED });
				break;
			case COMPONENTS_NAMES.LOGBOOK:
				dispatch({ type: types.UI_LOGBOOK_OPENED });
				break;
			case COMPONENTS_NAMES.INBOX:
				dispatch({ type: types.UI_INBOX_OPENED });
				break;
			case COMPONENTS_NAMES.LEVELS_MODAL:
				dispatch({ type: types.UI_LEVELS_MODAL_OPENED });
				break;
			case COMPONENTS_NAMES.GAME_MENU:
				dispatch({ type: types.UI_GAME_MENU_OPENED });
				break;
			default:
				break;
		}

		dispatch({ type: types.UI_ACTIVE_COMPONENT_ADDED, activeComponentName });
	};
}

export function notifyAsClosedComponent(activeComponentName) {
	return (dispatch) => {
		switch (activeComponentName) {
			case COMPONENTS_NAMES.PROCUREMENT:
				dispatch({ type: types.UI_PROCUREMENT_CLOSED });
				break;
			case COMPONENTS_NAMES.INBOX:
				dispatch({ type: types.UI_INBOX_CLOSED });
				break;
			case COMPONENTS_NAMES.LEVELS_MODAL:
				dispatch({ type: types.UI_LEVELS_MODAL_CLOSED });
				break;
			case COMPONENTS_NAMES.GAME_MENU:
				dispatch({ type: types.UI_GAME_MENU_CLOSED });
				break;
			case COMPONENTS_NAMES.LOGBOOK:
				dispatch({ type: types.UI_LOGBOOK_CLOSED });
				break;
			default:
				break;
		}

		dispatch({ type: types.UI_ACTIVE_COMPONENT_REMOVED, activeComponentName });
	};
}


export function notifyLogbookGeneralTabClosed() {
	return { type: types.UI_LOGBOOK_GENERAL_TAB_CLOSED };
}

export function notifyLogbookSalesTabClosed() {
	return { type: types.UI_LOGBOOK_SALES_TAB_CLOSED };
}

export function notifyLogbookPurchasesTabClosed() {
	return { type: types.UI_LOGBOOK_PURCHASES_TAB_CLOSED };
}

export function notifyAllCustomersAreHandled() {
	return { type: types.UI_CUSTOMERS_ALL_HANDLED };
}

export function productSellingPriceChanged(productType) {
	return (dispatch, getState) => {
		const currentsellingPricesChanged = uiSelectors.getsellingPricesChanged(getState());
		if (_isAllSellingPricesChanged(currentsellingPricesChanged)) {
			return;
		}

		const updatedSellingPricesChanged = {
			...currentsellingPricesChanged,
			[productType]: true
		};

		dispatch({
			type: types.UI_PRODUCTS_PRODUCT_SELLING_PRICE_CHANGED,
			updatedSellingPricesChanged
		});

		if (_isAllSellingPricesChanged(updatedSellingPricesChanged)) {
			dispatch({ type: types.UI_PRODUCTS_ALL_SELLING_PRICES_CHANGED });
		}
	};
}

export function changedNumberOfProductsToPurchase(productsToPurchase, hasEnoughCash) {
	return (dispatch) => {
		if (hasEnoughCash && _isAtLeast2ProductsNumberToPurchaseChanged(productsToPurchase)) {
			dispatch({ type: types.UI_PRODUCTS_CHANGED_2_PRODUCTS_NUMBER_TO_PURCHASE });
		}
	};
}

export function setUpUiForNewGame() {
	return (dispatch, getState) => {
		const selectedCharacterSlug = characterSelectors.getSelectedCharacterSlug(getState());

		if (selectedCharacterSlug === CHARACTERS_SLUG.AHMET) {
			dispatch(changeActiveModal(MAIN_SCREEN_MODALS.POWER));
		} else {
			dispatch(changeActiveModal(MAIN_SCREEN_MODALS.WELCOME));
		}

		if (selectedCharacterSlug === CHARACTERS_SLUG.TOOHA) {
			dispatch(shouldDisplayPowerModalForProcurementScreen(true));
		}

		if (selectedCharacterSlug === CHARACTERS_SLUG.KAKAK) {
			dispatch(shouldDisplayPowerModalFoHrScreen(true));
		}

		dispatch({
			type: types.UI_UPDATE_HAS_PENDING_CUSTOMER_TYPE_HINTS,
			hasPendingCustomerTypeHint: true
		});
		
	};
}

export function showFinancialStatementTutorial(tutorialKey, isAutomated = false) {
	return (dispatch, getState) => {
		const displayedStatement = financialStatementsSelectors.getDisplayedStatement(getState());
		const gameUserId = gameSelectors.getGameId(getState());

		if (displayedStatement === FINANCIAL_STATEMENTS_TABS.INCOME_STATEMENT) {
			dispatch({ type: types.UI_SHOW_INCOME_STATEMENT_TUTORIAL, tutorialKey, isAutomated });
		}

		if (displayedStatement === FINANCIAL_STATEMENTS_TABS.BALANCE_SHEET) {
			dispatch({ type: types.UI_SHOW_BALANCE_SHEET_TUTORIAL, tutorialKey, isAutomated });
		}

		if (displayedStatement === FINANCIAL_STATEMENTS_TABS.FINANCIAL_RATIOS) {
			dispatch({ type: types.UI_SHOW_FINANCIAL_RATIOS_TUTORIAL, tutorialKey, isAutomated });
		}

		if (isAutomated) {
			const storageType = getTutorialStorageType(tutorialKey)
				|| (displayedStatement === FINANCIAL_STATEMENTS_TABS.INCOME_STATEMENT ? 'incomeStatement'
					: displayedStatement === FINANCIAL_STATEMENTS_TABS.BALANCE_SHEET ? 'balanceSheet'
					: 'financialRatios');
			setTutorialStep(gameUserId, storageType, tutorialKey);
		}
	};
}

export function hideFinancialStatementTutorial() {
	return (dispatch, getState) => {
		const displayedStatement = financialStatementsSelectors.getDisplayedStatement(getState());

		if (displayedStatement === FINANCIAL_STATEMENTS_TABS.INCOME_STATEMENT) {
			dispatch({ type: types.UI_HIDE_INCOME_STATEMENT_TUTORIAL });
		}

		if (displayedStatement === FINANCIAL_STATEMENTS_TABS.BALANCE_SHEET) {
			dispatch({ type: types.UI_HIDE_BALANCE_SHEET_TUTORIAL });
		}

		if (displayedStatement === FINANCIAL_STATEMENTS_TABS.FINANCIAL_RATIOS) {
			dispatch({ type: types.UI_HIDE_FINANCIAL_RATIOS_TUTORIAL });
		}
	};
}

export function markFinancialStatementTutorialDone() {
	return (dispatch, getState) => {
		const displayedStatement = financialStatementsSelectors.getDisplayedStatement(getState());
		const gameUserId = gameSelectors.getGameId(getState());
		const activeTutorialKey = uiSelectors.getActiveFinancialStatementTutorial(getState());

		const storageType = getTutorialStorageType(activeTutorialKey)
			|| (displayedStatement === FINANCIAL_STATEMENTS_TABS.INCOME_STATEMENT ? 'incomeStatement'
				: displayedStatement === FINANCIAL_STATEMENTS_TABS.BALANCE_SHEET ? 'balanceSheet'
				: 'financialRatios');

		setTutorialStep(gameUserId, storageType, 'done');
		dispatch(hideFinancialStatementTutorial());
	};
}


export function updateShouldShowLevelStory(show) {
	return { type: types.UI_UPDATE_SHOULD_SHOW_LEVEL_STORY, shouldShowLevelStory: show };
}

export function openDraggable(draggable) {
	return (dispatch) => {
		dispatch(setDraggableComponentVisibility(draggable, true));
	};
}

export function closeDraggable(draggable) {
	return (dispatch) => {
		dispatch(setDraggableComponentVisibility(draggable, false));
	};
}

export function setupUiAfterReload(gameUser) {
	return (dispatch, getState) => {
		if (gameUser.level === 1 && gameUser.turns === 1 && !gameUser.store_name) {
			const selectedCharacterSlug = characterSelectors.getSelectedCharacterSlug(getState());

			if (selectedCharacterSlug === CHARACTERS_SLUG.AHMET) {
				dispatch(changeActiveModal(MAIN_SCREEN_MODALS.POWER));
			} else {
				dispatch(changeActiveModal(MAIN_SCREEN_MODALS.WELCOME));
			}
		}

		const doesLevelHasNewCustomerTutorial = LEVELS_WITH_NEW_CUSTOMER_TYPES.includes(gameUser.level);

		if (!doesLevelHasNewCustomerTutorial) {
			return
		}

		const isFirstMonthInLevel = gameUser.turns === gameUser.missions[0]?.startedInTurn;
		
		//	this flag can only be set in preparation phase
		//	if the user refreshes in the customer phase then tutorial
		//	will already be shown
		const isPrepPhase = gameUser.turn_phase === TURN_PHASES.PREPARATION;
		if(isPrepPhase && isFirstMonthInLevel) {
			dispatch({
				type: types.UI_UPDATE_HAS_PENDING_CUSTOMER_TYPE_HINTS,
				hasPendingCustomerTypeHint: true
			});
		}
	}
}

export function onCloseHealthBarTutorial() {
	return (dispatch) => {
		dispatch(closeDraggable(DRAGGABLE_COMPONENTS.HEALTH_BAR_TUTORIAL));
		dispatch({
			type: types.UI_LEVEL_NEW_MODAL_CLOSED,
			closed: true,
		});
	}

}

export function onCloseBreakevenTutorial() {
	return (dispatch) => {
		dispatch(closeDraggable(DRAGGABLE_COMPONENTS.BREAKEVEN_TUTORIAL));
		dispatch({
			type: types.UI_LEVEL_NEW_MODAL_CLOSED,
			closed: true,
		});
	}
}

export function fetchingNetworkRequest() {
	return (dispatch) => {
		dispatch({ type: types.UI_FETCHING_NETWORK_REQUEST });
	}
}


export function resetPowerModalsAfterLevelUp(level) {
	return async (dispatch, getState) => {
		const selectedCharacterSlug = characterSelectors.getSelectedCharacterSlug(getState());

		if (level === 1) {
			if (selectedCharacterSlug === CHARACTERS_SLUG.AHMET) {
				dispatch(changeActiveModal(MAIN_SCREEN_MODALS.POWER));
			}
			if (selectedCharacterSlug === CHARACTERS_SLUG.TOOHA) {
				dispatch(shouldDisplayPowerModalForProcurementScreen(true));
			}
		}
		if (level === LEVELS_TO_UNLOCK_FEATURES.HUMAN_RESOURCES) {
			if (selectedCharacterSlug === CHARACTERS_SLUG.KAKAK) {
				dispatch(shouldDisplayPowerModalFoHrScreen(true));
			}
		}
	}
}
